export default __webpack_public_path__ + "static/media/slide-cell-2.3057e0f0.svg";